import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.875),
    backgroundColor: theme.palette.modal.default,
    borderRadius: theme.spacing(1.25),
    cursor: 'pointer',
  },

  text: {
    overflow: 'hidden',
    width: 'auto',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  name: {
    textDecoration: 'underline',
    textTransform: 'capitalize',
    maxWidth: '80%',
  },

  roleName: {
    color: theme.palette.text.secondary,

    '&.MuiTypography-root': {
      fontSize: theme.spacing(1.5),
    },
  },

  userInfo: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
}));
